import { api } from '@services';

import qs from 'query-string';

import { IPaginationResult } from '@models/Equipment.model';
import Task, { ITaskApiRawQuery, ITaskRawQuery } from '@models/Task.model';
import { DirectionTaskstypes, SortTasksTypes } from '@pages/Tasks/Tasks.query';

interface IRequest {
  studioId: string;
  page: number;
  limit: number;
  status?: string;
  search?: string;
  assigneeId?: string;
  sort?: SortTasksTypes;
  direction?: DirectionTaskstypes;
}

const getTasks = async ({
  limit,
  page,
  studioId,
  search,
  status,
  assigneeId,
  direction,
  sort,
}: IRequest): Promise<IPaginationResult<ITaskRawQuery>> => {
  const query = {
    page,
    limit,
    q: search,
    status,
    assigneeId,
    direction,
    sort,
  };

  const queryString = qs.stringify(query);

  const { data: tasks } = await api.get<IPaginationResult<ITaskApiRawQuery>>(
    `/studios/${studioId}/tasks?${queryString}`,
  );

  return Task.arrayPaginatedFromRawQueryModel(tasks);
};

export { getTasks };
